const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 07/12/16.
 */

const React = require('react');

const { formatText } = require('core/i18n').i18n;
const { OKTextArea } = require('commonsComponents/OKTextArea');
require('../politicalCharge.scss');

class PoliticalChargeDescription extends React.Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }


    handleChange(event) {
        this.props.handleTextareaChange(event);
    }

    render() {
        return (
            <div className="political-charge__form-element">
                <OKTextArea
                    value={this.props.state.politicalChargeDescription}
                    label={formatText('contractsView-checkingAccountPoliticalChargeDescriptionTextAreaLabel')}
                    onChange={this.handleChange}/>
            </div>
            );
    }
}

PoliticalChargeDescription.propTypes = {
    state: PropTypes.object,
    handleTextareaChange: PropTypes.func,
    values: PropTypes.object
};

module.exports = PoliticalChargeDescription;